import React, { Component } from 'react';
import ScrollToTopOnMount from '../scroll_top';
import { confirmAlert } from 'react-confirm-alert';
import _ from "lodash";

export default class FoliosTable extends Component {
	render() {
		const { projects, entities } = this.props;
		const { modality } = this.props.match.params;
		let pc = _.find(projects.permissions, (o) => {return o==='Create'});
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<ScrollToTopOnMount {...this.props}/>
					<h5 className="title is-5">Folios de proyectos{modality === 'modalidad-i' ? ' - Modalidad I' : (modality === 'modalidad-ii' ? ' - Modalidad II' : ' - Modalidad III')}</h5>
					{!_.isEmpty(projects.folios) ?
						<table className="is-fullwidth table project-goal-table no-margin">
							<tbody>
							{_.map(projects.folios, (item , k) => {
								let stateInfo = undefined;
								if(modality === 'modalidad-ii' && item.agency && item.agency && item.agency.agenciable){
									stateInfo = _.find(entities.list, {id: item.agency.agenciable.state_id});
								}
								return [
									<tr key={`instance-${k}`}>
										<td className="goal-cell" style={{width:'10%'}}>
											<span className="help is-white">Folio</span>
											<strong>{item.code ? item.code:'---'}</strong>
										</td>
										<td className="goal-cell" style={{width:'70%'}}>
											<span className="help is-white">Instancia</span>
											<strong>{item.agency && item.agency.name ? item.agency.name:'---'}</strong>
										</td>
										<td className="goal-cell">
											<span className="help is-white">Estado</span>
											{modality !== 'modalidad-ii' ?
												<strong>{item.agency && item.agency && item.agency.agenciable ? item.agency.agenciable.name:'---'}</strong>
												:<strong>{stateInfo ? stateInfo.name:'---'}</strong>}
											{modality === 'modalidad-ii' ? <span className="help is-white">Municipio</span>:''}
											{modality === 'modalidad-ii' ? <strong>{item.agency && item.agency && item.agency.agenciable ? item.agency.agenciable.name:'---'}</strong>:''}
										</td>
									</tr>,
									<tr key={`general-${k}`}>
										<td colSpan={3}>
											<span className="help is-dark">Titular</span>
											<strong>{item.agency && item.agency && item.agency.owner ? `${item.agency.owner.title} ${item.agency.owner.name} ${item.agency.owner.last_name} ${item.agency.owner.slast_name}`:'---'}</strong>
										</td>
									</tr>
								];
							})}
							</tbody>
						</table>:<p className="has-text-primary"><span className="icon has-text-danger"><i className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br /></p>}

					<div className="columns ">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
								</div>

								{pc ?
								<div className="control">
									<button className="button is-large is-inm-purple" onClick={() => this._handleClick()} disabled={projects.codes_assigned || _.isEmpty(projects.folios)}>Asignar Folios</button>
								</div>:''}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_handleClick() {
		let { modality } = this.props.match.params;
		confirmAlert({
			title: '¿Está seguro?',
			message: 'Esta acción es irreversible. Una vez asignados los folios, no podrán ser restablecidos.',
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => {
				this.props.projectsFoliosAssign(modality);
			}
		})
	}

	/*_permissionSave() {
		const { projects } = this.props;
		//let agencies =_.filter(projects.list,(o) => {return o.project_precode});
		//console.log('agencies: ',agencies);
		if(_.isEmpty(agencies)){
			return true
		}else {
			return false
		}
	}*/
}


// WEBPACK FOOTER //
// ./src/elements/projects/folios.jsx